var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/utils.ts";
import "core-js/modules/es.object.keys.js";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function isEmpty(value) {
  return !!value && !Object.keys(value).length;
}